import { InjectionToken } from '@angular/core';
import { Package } from './package.interface';

export const RUNNABLE_PACKAGE = new InjectionToken<RunnablePackage>('RunnablePackage');

export interface RunnablePackage extends Package {
	runPackage(): Promise<void>;
}